import { AsyncStoreItem } from '@lib/store';
import { ExchangeAvailabilityResponse } from 'src/sdk-member';

/**
 * ExchangeAvailability model
 */
export interface ExchangeAvailabilityModel {
  model: ExchangeAvailabilityResponse | null;
}

/**
 * ExchangeAvailabilityResponse model details
 */
export interface ExchangeAvailabilityStateDetails extends AsyncStoreItem {}

/**
 * ExchangeAvailability store state
 */
export interface ExchangeAvailabilityState extends ExchangeAvailabilityStateDetails, ExchangeAvailabilityModel {}

/**
 * Name of the ExchangeAvailability Store
 */
export const EXCHANGE_AVAILABILITY_STORE_NAME = 'exchangeAvailability';

/**
 * ExchangeAvailability Store Interface
 */
export interface ExchangeAvailabilityStore {
  /** ExchangeAvailability state */
  [EXCHANGE_AVAILABILITY_STORE_NAME]: ExchangeAvailabilityState;
}
